import { WidgetType } from '@codemirror/view'
import { FormulaDisplayColumn, getTableColumnDisplay } from '@doss/common-all'
import { Root, createRoot } from 'react-dom/client'
import { FormulaColumnChip } from '~/components/formula/FormulaColumnChip'

/**
 * The code mirror widget for displaying a column chip.
 * Accepts FormulaDisplayColumn which contains the minimal fields needed for display.
 */
export class ColumnChipWidget extends WidgetType {
  private domNode: HTMLSpanElement
  private root: Root
  private tableColumn: FormulaDisplayColumn
  private hasError: boolean
  private tableId: string | undefined

  constructor(tableColumn: FormulaDisplayColumn, tableId: string | undefined, hasError: boolean) {
    super()

    this.tableColumn = tableColumn
    this.tableId = tableId
    this.hasError = hasError

    // Create the DOM node to host the React component
    this.domNode = document.createElement('span')
    this.domNode.className = hasError ? 'column-chip-error' : 'column-chip' // Applying class for possible CSS targeting

    // If the column is on the same table as the formula, just use the formula name.
    // Otherwise, also display the table display
    const tableDisplay = getTableColumnDisplay(this.tableColumn, this.tableId)

    // Setting index to 5 so columns on the same table as the formula will be orange.
    // Setting index to 4 so columns not on the same table as the formula will be purple
    const index = this.tableId && this.tableId === this.tableColumn.table.id ? 5 : 4

    // Initialize React on this DOM node
    this.root = createRoot(this.domNode)
    // this.updateRender()
    this.root.render(
      <div>
        <FormulaColumnChip index={index} name={tableDisplay} />
      </div>,
    )
  }

  getTableColumn() {
    return this.tableColumn
  }

  eq(other: ColumnChipWidget) {
    return other.tableColumn.id === this.tableColumn.id && other.hasError === this.hasError
  }

  toDOM() {
    return this.domNode
  }

  ignoreEvent() {
    return false // Allow events on the chip, or true to ignore events
  }

  destroy() {
    // Schedule unmount asynchronously to avoid React 18 warnings about
    // unmounting during render
    setTimeout(() => {
      this.root.unmount()
    }, 0)
  }
}
